module.exports = __webpack_public_path__ + "static/img/006.112562a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/intellectual_property/006.jpg
// module id = M/go
// module chunks = 0